import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { Shield, Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23, 47, 32);
  const items = ['Ebook Principal (50 págs)', 'Lista de Compras Perfecta', 'Checklist Bioseñales 40+', 'Guía Sustitutos Latinos', 'Plan Comidas 15 Minutos', 'Recetario Licuados Metabólicos'];
  return <section id="final-cta" className="w-full bg-gradient-to-b from-orange to-[#C0392B] py-20 px-4" data-id="element-56">
      <div className="max-w-[760px] mx-auto flex flex-col items-center text-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/20 text-white text-[13px] font-bold px-4 py-1.5 rounded-full mb-8" data-id="element-58">
          ⚡ OFERTA TERMINA PRONTO
        </motion.div>

        {/* Countdown Timer */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex items-start justify-center gap-2 md:gap-4 mb-10" data-id="element-59">
          <div className="flex flex-col items-center" data-id="element-60">
            <div className="bg-white text-dark font-mono font-bold text-[36px] md:text-[48px] px-3 md:px-4 py-2 rounded-lg shadow-lg min-w-[70px] md:min-w-[80px]" data-id="element-61">
              {hours}
            </div>
            <span className="text-white text-[12px] mt-2 font-medium" data-id="element-62">
              Horas
            </span>
          </div>
          <div className="text-white text-[36px] md:text-[48px] font-bold mt-1" data-id="element-63">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-64">
            <div className="bg-white text-dark font-mono font-bold text-[36px] md:text-[48px] px-3 md:px-4 py-2 rounded-lg shadow-lg min-w-[70px] md:min-w-[80px]" data-id="element-65">
              {minutes}
            </div>
            <span className="text-white text-[12px] mt-2 font-medium" data-id="element-66">
              Minutos
            </span>
          </div>
          <div className="text-white text-[36px] md:text-[48px] font-bold mt-1" data-id="element-67">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-68">
            <div className="bg-white text-dark font-mono font-bold text-[36px] md:text-[48px] px-3 md:px-4 py-2 rounded-lg shadow-lg min-w-[70px] md:min-w-[80px]" data-id="element-69">
              {seconds}
            </div>
            <span className="text-white text-[12px] mt-2 font-medium" data-id="element-70">
              Segundos
            </span>
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[28px] md:text-[36px] font-bold text-white mb-4" data-id="element-71">
          Invierte $6.36 USD en tu Mejor Versión Hoy
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[16px] md:text-[18px] text-white/85 mb-10 max-w-lg" data-id="element-72">
          Menos de lo que cuesta un café. Más que suficiente para cambiar tu
          metabolismo.
        </motion.p>

        {/* Quick List */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 mb-10 text-left w-full max-w-xl" data-id="element-73">
          {items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-74">
              <span className="text-lime text-lg" data-id="element-75">✅</span>
              <span className="text-[15px] text-white font-medium" data-id="element-76">{item}</span>
            </div>)}
        </motion.div>

        {/* CTA Button */}
        <motion.a href="https://novadigitalventures.com/cart/42605652836423:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} className="w-full md:w-auto bg-white text-orange text-[18px] md:text-[20px] font-bold py-5 px-8 md:px-12 rounded-xl shadow-[0_6px_24px_rgba(0,0,0,0.25)] hover:bg-gray-50 transition-colors mb-6 text-center inline-block" data-id="element-77">
          SÍ, QUIERO MI REINICIO 40+ POR $6.36 →
        </motion.a>

        {/* Trust Elements */}
        <div className="flex flex-col items-center gap-4 w-full" data-id="element-78">
          <div className="flex items-center gap-2 text-[14px] text-white/80" data-id="element-79">
            <Lock size={16} data-id="element-80" /> Pago 100% Seguro con Encriptación SSL
          </div>

          <div className="flex items-center gap-4 text-white/70 font-bold text-sm" data-id="element-81">
            <span data-id="element-82">VISA</span>
            <span data-id="element-83">MASTERCARD</span>
            <span data-id="element-84">PAYPAL</span>
          </div>

          <div className="flex items-center justify-center gap-2 text-[14px] text-white/90 mt-2 bg-black/10 py-2 px-4 rounded-lg w-full max-w-md" data-id="element-85">
            <Shield size={16} className="text-white" data-id="element-86" />
            <span data-id="element-87">
              Garantía de 7 días — Si no te satisface, te devolvemos tu dinero
              sin preguntas
            </span>
          </div>
        </div>
      </div>
    </section>;
}